var map = {
	"./construction.png": 16553,
	"./disappointed-face.png": 61909,
	"./loudly-crying-face.png": 16706,
	"./sad-face.png": 37279,
	"./smiling-face.png": 77313,
	"./spiral-calendar.png": 55031,
	"./star.png": 29119,
	"./tada.png": 17371,
	"./thinking-face.png": 13227,
	"./white-check-mark.png": 96298
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 34807;